
import state from './moduleSDSubStatusManagementState'
import mutations from './moduleSDSubStatusManagementMutations'
import actions from './moduleSDSubStatusManagementActions'
import getters from './moduleSDSubStatusManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

